import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import {ReactComponent as GooglePlaySVG} from '../assets/svgs/google-play-svg.svg'


const Title = styled.div`
        font-size: 40px;
        display:flex;
        // color: #385963;
         color: white;
        font-weight: 400;
        margin-bottom: 10px;
        font-size: 25px;
        @media (max-width: 768px) {
          font-size:14px;
        }
   `;

const AppContainer = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    background-color: #91abb3;
    padding: 30px;
    
    @media (max-width: 768px) {
      height:120px;
       padding: 15px;
    }
`; 

const AndroidApp = styled.div`
     border:  solid 2px  #385963;
     border-radius: 10px;
     width: 200px;
     padding: 5px;
     margin-left: 100px;
     display:flex;
     background-color: white;
     align-items:center;
    
     svg{
        height:50px;
        width:50px;
     }
      @media (max-width: 600px) {
      margin-left: 50px;
      //  height: 60px;
      //  width: 180px;
       height: auto;
       width: ${({ selectedLanguage }) => (selectedLanguage === 'gr' ? '220px' : '170px')};
       padding:5px;
        svg{
        height:40px;
        width:40px;
     }
     }
`;

export const TextContainer = styled.div`
  display:flex;
  flex-direction: column;
  justify-content:center;
  margin: 0px 10px;
 
`;

export const DownLoadText = styled.div`
   color:  #385963;
   font-size: 10px;
   font-weight: 500;
    @media (max-width: 768px) {
      font-size:10px;
    }
`;

export const GooglePlay = styled.div`
   color:  #385963;
    font-size: 20px;
    font-weight: 500;
      @media (max-width: 768px) {
      font-size:14px;
    }
`;


const DownLoadMobileApp = () => {

    const { i18n } = useTranslation();
    const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';

  return (
    <AppContainer>
        {/* <Title>{i18n.t('downloadMobileApp')}</Title> */}
        {/* <AndroidApp selectedLanguage={selectedLanguage}>
            <GooglePlaySVG/>
            <TextContainer>
                <DownLoadText> {i18n.t('downloadOn')}</DownLoadText>
                <GooglePlay>{i18n.t('googlePlay')}</GooglePlay>
            </TextContainer>
        </AndroidApp> */}
    </AppContainer>
  )
}

export default DownLoadMobileApp
